import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { categories, channels } from "@/mocks/news";

const navItems = [
  { label: "娱乐新闻", to: "/category/entertainment-news" },
  { label: "明星八卦", to: "/category/star-gossip" },
  { label: "影视音乐", to: "/category/film-music" },
  { label: "综艺动态", to: "/category/variety-show" },
  { label: "独家爆料", to: "/category/exclusive" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [expandCategory, setExpandCategory] = useState(false);
  const [expandChannel, setExpandChannel] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setExpandCategory(false);
    setExpandChannel(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  };

  const isActive = (to: string) => location.pathname === to;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="hidden md:block bg-secondary-900 text-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-9 flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <i className="ri-fire-line text-accent-400" />
            <span className="text-background-200">今日热搜：顶流男星新片开机 · 女歌手巡演售罄 · 盛典红毯群星闪耀</span>
          </div>
          <div className="flex items-center gap-5">
            <Link to="/about" className="hover:text-accent-400 cursor-pointer transition-colors">
              关于我们
            </Link>
            <Link to="/contact" className="hover:text-accent-400 cursor-pointer transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-16 flex items-center gap-4 justify-between">
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-2xl text-foreground-900 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className="ri-menu-3-line" />
          </button>
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
              <i className="ri-fire-fill" />
            </span>
            <span className="leading-none">
              <span className="block font-heading font-black text-xl text-foreground-950 tracking-tight">
                吃瓜爆料网
              </span>
              <span className="hidden sm:block text-[11px] text-foreground-500 tracking-[0.2em] mt-0.5">
                GOSSIP NEWS
              </span>
            </span>
          </Link>
        </div>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                isActive(item.to)
                  ? "text-primary-600 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden md:flex items-center flex-1 max-w-xs ml-auto lg:ml-4">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索明星、八卦、影视…"
              className="w-full h-10 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </div>
        </form>

        <Link
          to="/contact"
          className="hidden md:flex items-center gap-1.5 h-10 px-4 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          <i className="ri-send-plane-fill" />
          爆料投稿
        </Link>
      </div>

      <form onSubmit={submitSearch} className="md:hidden px-4 pb-3">
        <div className="relative w-full">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索明星、八卦、影视…"
            className="w-full h-10 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
          />
        </div>
      </form>

      {/* Mobile drawer */}
      <div
        className={`md:hidden fixed inset-0 z-[60] transition-opacity ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="absolute inset-0 bg-foreground-950/50" onClick={() => setMenuOpen(false)} />
        <aside
          className={`absolute left-0 top-0 h-full w-[280px] max-w-[82vw] bg-background-50 flex flex-col transition-transform duration-300 ${
            menuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="h-16 px-4 flex items-center justify-between border-b border-background-200">
            <span className="font-heading font-black text-lg text-foreground-950">吃瓜爆料网</span>
            <button
              type="button"
              onClick={() => setMenuOpen(false)}
              className="w-9 h-9 flex items-center justify-center text-2xl text-foreground-700 cursor-pointer"
              aria-label="关闭菜单"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-3 py-4">
            <p className="px-2 py-2 text-xs font-bold tracking-widest text-foreground-400">栏目导航</p>
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`flex items-center gap-2 px-3 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                  isActive(item.to) ? "bg-primary-50 text-primary-600" : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}

            <button
              type="button"
              onClick={() => setExpandCategory((v) => !v)}
              className="w-full flex items-center justify-between px-3 py-3 rounded-lg text-sm font-medium text-foreground-800 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-apps-2-line" /> 全部分类
              </span>
              <i className={`ri-arrow-down-s-line transition-transform ${expandCategory ? "rotate-180" : ""}`} />
            </button>
            {expandCategory && (
              <div className="pl-4">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-foreground-600 cursor-pointer hover:bg-background-100"
                  >
                    <i className={c.icon} />
                    {c.name}
                  </Link>
                ))}
              </div>
            )}

            <button
              type="button"
              onClick={() => setExpandChannel((v) => !v)}
              className="w-full flex items-center justify-between px-3 py-3 rounded-lg text-sm font-medium text-foreground-800 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-live-line" /> 专题频道
              </span>
              <i className={`ri-arrow-down-s-line transition-transform ${expandChannel ? "rotate-180" : ""}`} />
            </button>
            {expandChannel && (
              <div className="pl-4">
                {channels.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/channel/${c.slug}`}
                    className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-foreground-600 cursor-pointer hover:bg-background-100"
                  >
                    <i className={c.icon} />
                    {c.name}
                  </Link>
                ))}
              </div>
            )}

            <Link
              to="/contact"
              className="mt-3 flex items-center justify-center gap-2 px-3 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              <i className="ri-send-plane-fill" /> 我要爆料
            </Link>
          </div>
        </aside>
      </div>
    </header>
  );
}